export default "__VITE_ASSET__ByNXgnf___"